// extracted by mini-css-extract-plugin
module.exports = {"CourseContentPageInfo":"CourseContentPageInfo_CourseContentPageInfo__1qiSv","Header":"CourseContentPageInfo_Header__b1yez"};